import React from 'react';
import release from "../../img/Release.jpg";
import spec from "../../img/spec.jpg";
import warranty from "../../img/warranty.jpg";
import terms from "../../img/terms.jpg";



function ClientManualScrollPlant(){

    return (
       
        <>
            <div className="wrapper">
  <section id="section1">
   
    <a  class="arrow__btn" style={{paddingTop:"60px"}}></a> {/* */}
    <div className="item" style={{marginLeft:"25px"}}>
    <img src={warranty} alt="Describe Image" style={{width:"255px"}} />
  </div>
    
   
    
  
    <a href="#section2" class="arrow__btn" style={{paddingTop:"60px"}}>  
    <span class="material-symbols-rounded arrow2">arrow_circle_right</span>
    </a>
  </section>
  <section id="section2">
    <a href="#section1" class="arrow__btn" style={{paddingTop:"60px"}}>
    <span class="material-symbols-rounded arrow2">arrow_circle_left</span>
    </a>
   
  <div className="item" style={{marginLeft:"40px"}}>
    <img src={terms} alt="Describe Image" style={{width:"255px"}} />
  </div>
  
  {/* 
    <a href="#section1" class="arrow__btn"  style={{paddingTop:"60px"}}>
    <span class="material-symbols-rounded arrow2">arrow_circle_right</span>
    </a>*/}
  </section>

</div>
        </>
    )
}

export default ClientManualScrollPlant;